import {createMuiTheme} from 'material-ui/styles';
import red from 'material-ui/colors/red';

export const overrideTheme = createMuiTheme({
    overrides: {
        MuiCollapse: {
            entered: {
                overflow: 'visible',
            },
        },
    },
});

export const styles = (theme) => ({
    paper: {
        display: 'flex',
        margin: theme.spacing.unit * 4,
        flexDirection: 'column',
        flex: '0 1 auto',
        position: 'relative',
        maxHeight: '90vh',
        overflowY: 'auto',
        backgroundColor: '#eeeeee',
        '&:focus': {
            outline: 'none',
        },
    },
    button: {
        margin: theme.spacing.unit,
    },
    dialogActionsBtn: {
        margin: '8px 19px',
    },
    fullWidth: {
        width: '80%',
    },
    hasErrors: {
        color: red[500],
    },
    galleryError: {
        background: red[500],
        color: '#fff',
    },
});



// WEBPACK FOOTER //
// ./src/containers/builder/style/text_section.js